import { IFilterModel, IListModel } from 'shared/models/List'

export interface IBuildingAddressModel {
  address: string
  zip: string
  city: string
  countryCode: string
  addressId: number
}

export interface IBuildingResultModel extends IListModel {
  result: IBuildingSingleResult[]
}

export interface IBuildingFilterModel extends Omit<IFilterModel, 'sortcolumn'> {
  buildingType?: string
  numberOfUnits?: number
  clientId: string | null
  // Had to replace because different casing on sortcolumn
  sortColumn: string
}

export interface IBuildingSingleResult {
  id: number
  name: string
  buildingType: string
  buildingCode: string
  numberOfUnits: string | null
  addresses: IBuildingAddressModel[]
}

export interface IBuildingDetail {
  numberOfBalconys: number
  numberOfFireBalconys: number
  numberOfGarbageBins: number
  numberOfPipes: number
  numberOfFloors: number
  numberOfEntrances: number
  builtYear: number
  finishedDate: Date
  facadeType: string
  buildingClass: string
  roofType: string
  heating: string
  protectionStatus: string
  constructionType: string
  id: string
  name: string
  buildingType: string
  buildingCode: string
  addresses: IBuildingAddressModel[]
  numberOfUnits: number
}

export enum IBuildingSortFieldEnum {
  name = 'Name',
  numberOfUnits = 'NumberOfUnits',
  buildingType = 'BuildingType',
}
